import { createCommand } from '@eastcoal/editor/exports'

import { InsertTableVariablePayload } from './interface'

export const INSERT_TABLE_VARIABLE_COMMAND =
  createCommand<InsertTableVariablePayload>('INSERT_TABLE_VARIABLE_COMMAND')
